import { markForcedRedirect } from '~/utils/emailVerification'

export default async function(ctx) {
  // Validate if for Recurly migration
  if (ctx.$auth && ctx.$auth.user) {
    // Redirect to terms only if user has an active plan
    const {
      cancelled,
      isForMigration,
      isForNupiMigration,
      edu_verification_pending,
      edu_url
    } = ctx.$auth.user

    // Redirect to Console verification for unverified university users
    if (edu_verification_pending && edu_url) {
      markForcedRedirect()
      window.location.assign(
        `${process.env.CONSOLE_APP_URL}/edu/${edu_url}/almostdone/pending`
      )
      return
    }

    if (isForMigration && !cancelled) {
      const encoded = encodeURI(window.location.href)
      markForcedRedirect()
      location.assign(
        `${
          process.env.CONSOLE_APP_URL
        }/account/terms?code=ncon&returl=${encoded}`
      )
      return
    }

    if (isForNupiMigration) {
      const encoded = encodeURI(window.location.href)
      markForcedRedirect()
      location.assign(
        `${process.env.CONSOLE_APP_URL}/account/terms/non-us?returl=${encoded}`
      )
      return
    }
  }

  const {
    country_access: countries,
    team = null
  } = ctx.store.state.userSubscriptions.features
  const plans = ctx.store.state.userSubscriptions.plans

  // For team accounts, redirect billing admin to Console
  const hasBillingAdminPlan =
    plans && plans.some(plan => plan.name === 'team-billing-admin')

  if (team && hasBillingAdminPlan) {
    markForcedRedirect()
    location.assign(`${process.env.CONSOLE_APP_URL}/account/team-management`)
    return
  }

  // Not for Recurly migration
  if (plans.length === 0 || !countries.includes('us')) {
    ctx.store.commit('setRedirectNonMigratedAccount', true)
  }

  if (ctx.store.state.redirectNonMigratedAccount) {
    markForcedRedirect()
    location.assign(`${process.env.CONSOLE_APP_URL}/dashboard?code=nvus`)
  }
}
